import { render, staticRenderFns } from "./EditRoutine.vue?vue&type=template&id=0495b672"
import script from "./EditRoutine.vue?vue&type=script&lang=js"
export * from "./EditRoutine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports